import _ from 'lodash';

import { getGa } from '../../../core/googleAnalytics';

type EventAction = 'CONTINUE_AFTER_BUSINESS_VERIFICATION_SUBMITTED_FOR_REVIEW';

type ReportPayload = {
  eventAction: EventAction;
  eventLabel?: string;
};

const report = (payload: ReportPayload) => {
  const ga = getGa();

  if (!_.isFunction(ga)) {
    return;
  }

  ga('send', { hitType: 'event', eventCategory: 'KYB_PROCESS', ...payload });
};

export const reportContinueAfterBusinessVerificationSubmittedForReview = () =>
  report({
    eventAction: 'CONTINUE_AFTER_BUSINESS_VERIFICATION_SUBMITTED_FOR_REVIEW',
  });
